import { render } from "./UserBar.vue?vue&type=template&id=af592e26&scoped=true"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import "./UserBar.vue?vue&type=style&index=0&id=af592e26&scoped=true&lang=css"
import "./UserBar.vue?vue&type=style&index=1&id=af592e26&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af592e26"]])

export default __exports__